// extracted by mini-css-extract-plugin
export default {"cls1":"AgilysysLogo_cls1__ROJ5G","cls2":"AgilysysLogo_cls2__4NL+o"};